import classNames from 'classnames'
import { Status } from 'feature/statuses/types'
import React from 'react'
import { Link } from 'ui'

import styles from './Chip.module.scss'

type TChip = {
  label: string
  status: Status
  link?: string
}

function ChipItem({
  children,
  status,
}: {
  status: TChip['status']
  children: React.ReactNode
}) {
  return (
    <div className={classNames(styles.chip, styles[status])}>
      <span className={classNames(styles.status, styles[status])} />
      <span className={styles.chipStatus}>{children}</span>
    </div>
  )
}

export function Chip({ status, link, label }: TChip) {
  if (link) {
    return (
      <Link href={link} className={styles.chipLink} underline='none'>
        <ChipItem status={status}>{label}</ChipItem>
      </Link>
    )
  }
  return <ChipItem status={status}>{label}</ChipItem>
}

Chip.defaultProps = {
  link: '',
}
